/* Theme safeguards only. A checkout validation app must enforce this rule server-side. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const isOrphan = cart => cart.items.length > 0 && cart.items.every(item => item.handle === 'package-protection');
  let pending;
  async function check() {
    if (pending) return pending;
    pending = (async () => {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Cart could not be checked.');
      const cart = await response.json();
      if (!isOrphan(cart)) return true;
      const updates = Object.fromEntries(cart.items.map(item => [item.key, 0]));
      const removed = await fetch(`${root}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates })
      });
      if (!removed.ok) throw new Error('Package Protection could not be removed.');
      window.location.assign(`${root}cart`);
      return false;
    })();
    try { return await pending; } finally { pending = null; }
  }
  function showError() {
    let message = document.getElementById('pp-protection-error');
    if (!message) {
      message = document.createElement('p');
      message.id = 'pp-protection-error';
      message.setAttribute('role', 'alert');
      (document.querySelector('main') || document.body).prepend(message);
    }
    message.textContent = 'We couldn’t check your cart. Please refresh and try again before checking out.';
    message.scrollIntoView({ block: 'center' });
  }
  customElements.define('pp-package-protection-guard', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.orphan === 'true') check().catch(showError);
    }
  });
  // Fresh validation also handles a cart changed in another tab before checkout.
  const approved = new WeakSet();
  document.addEventListener('submit', async event => {
    const form = event.target;
    const button = event.submitter;
    if (!button || button.name !== 'checkout' || approved.has(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.protectionChecking) return;
    form.dataset.protectionChecking = 'true';
    try {
      if (await check()) {
        approved.add(form);
        try { form.requestSubmit(button); } finally { approved.delete(form); }
      }
    } catch { showError(); }
    finally { delete form.dataset.protectionChecking; }
  }, true);
  window.addEventListener('pageshow', event => { if (event.persisted) check().catch(showError); });
})();
